import { render } from "./Stage.vue?vue&type=template&id=2b692250"
import script from "./Stage.vue?vue&type=script&lang=js"
export * from "./Stage.vue?vue&type=script&lang=js"
script.render = render

export default script